/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rememberyourpassword2Inputs */

const en_rememberyourpassword2 = /** @type {(inputs: Rememberyourpassword2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remember your password?`)
};

const de_rememberyourpassword2 = /** @type {(inputs: Rememberyourpassword2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort wieder eingefallen?`)
};

/**
* | output |
* | --- |
* | "Remember your password?" |
*
* @param {Rememberyourpassword2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const rememberyourpassword2 = /** @type {((inputs?: Rememberyourpassword2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rememberyourpassword2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rememberyourpassword2(inputs)
	return de_rememberyourpassword2(inputs)
});
export { rememberyourpassword2 as "rememberYourPassword" }